import { render, staticRenderFns } from "./EmailConfiguracao.vue?vue&type=template&id=2f94db66&"
import script from "./EmailConfiguracao.vue?vue&type=script&lang=js&"
export * from "./EmailConfiguracao.vue?vue&type=script&lang=js&"
import style0 from "./EmailConfiguracao.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports